import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Contact API
export const submitContactForm = async (contactData) => {
  try {
    const response = await api.post("/contact", contactData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to submit contact form" };
  }
};

// Application API
export const verifyPassword = async (password) => {
  try {
    const response = await api.post("/application/verify-password", {
      password,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Password verification failed" };
  }
};

export const submitLoanApplication = async (formData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/application/submit`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || { message: "Failed to submit loan application" }
    );
  }
};

// Netcash API
export const createDebitOrder = async (orderData) => {
  try {
    const response = await api.post("/netcash/debit-order", orderData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to create debit order" };
  }
};

export const verifyPayment = async (referenceId) => {
  try {
    const response = await api.get("/netcash/verify", {
      params: { referenceId },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to verify payment" };
  }
};

// Auth API
export const sendAccessCode = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/send-access-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to send access code");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const verifyAccessCode = async ({ code, email }) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/verify-access-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code, email }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Invalid access code");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export default api;
